export default [
  { naoNulo: true, tipo: 'string', atributo: 'nome', nome: 'Nome' },
  {
    naoNulo: true,
    tipo: 'string',
    atributo: 'turno.nome',
    nome: 'Turno',
  },
];
